import type { Fields } from "@vuex-orm/core";
// eslint-disable-next-line import/no-cycle
import { FileSlide } from "./ActionHierarchy";

export class VideoSlide extends FileSlide {
  // This is the name used as module name of the Vuex Store.
  public static entity = "videoSlides";

  public static baseEntity = "actions";

  public static fields(): Fields {
    return {
      ...super.fields(),
      screenshotUrl: this.string("").nullable(),
      playlistUrl: this.string("").nullable(),
    };
  }

  public static get humanName(): string {
    return "Video Slide";
  }

  public declare chromaKey: string | null;

  public declare screenshotUrl: string | null;

  public declare playlistUrl: string | null;

  public get hasChromaKey(): boolean {
    return (this.chromaKey || "").length > 0;
  }
}
